export default function HamburgerSVG() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="25"
      height="16"
      viewBox="0 0 25 16"
      fill="none"
      aria-label="เมนู"
    >
      <title>Hamburger button</title>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M0.464844 1.37676C0.464844 0.714016 1.0021 0.176758 1.66484 0.176758H23.2648C23.9276 0.176758 24.4648 0.714016 24.4648 1.37676C24.4648 2.0395 23.9276 2.57676 23.2648 2.57676H1.66484C1.0021 2.57676 0.464844 2.0395 0.464844 1.37676Z"
        fill="white"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M0.464844 7.63945C0.464844 6.97671 1.0021 6.43945 1.66484 6.43945H23.2648C23.9276 6.43945 24.4648 6.97671 24.4648 7.63945C24.4648 8.30219 23.9276 8.83945 23.2648 8.83945H1.66484C1.0021 8.83945 0.464844 8.30219 0.464844 7.63945Z"
        fill="white"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M0.464844 13.9021C0.464844 13.2394 1.0021 12.7021 1.66484 12.7021H23.2648C23.9276 12.7021 24.4648 13.2394 24.4648 13.9021C24.4648 14.5649 23.9276 15.1021 23.2648 15.1021H1.66484C1.0021 15.1021 0.464844 14.5649 0.464844 13.9021Z"
        fill="white"
      />
    </svg>
  );
}
